import Component from '@bythepixel/component-loader';

export default class FavoriteBanner extends Component {
  static selector = '[data-comp-dismiss-favorite-banner]';
  static bannerSelector = '[data-comp-favorite-banner]';

  static allowedGroups = [
    'rv',
    'cars-trucks-suvs-vans',
    'trucks',
    'trailers',
    'horse-livestock-trailers',
    'horse-trailers',
    'livestock-trailers',
  ];

  constructor(containerEl, options) {
    super(containerEl, options);

    this.$container.addEventListener(
      'click',
      this.removeExpiredFavorites.bind(this),
    );
  }

  removeExpiredFavorites() {
    this.hideBanner();

    const endpoint = '/api/inventory/favorite';
    const potentialGroup = window.location.pathname.split('/')[1];
    const group = FavoriteBanner.allowedGroups.includes(potentialGroup)
      ? potentialGroup
      : 'corporate';

    return fetch(`${endpoint}/${group}/`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  hideBanner() {
    const banner = this.$container.closest(FavoriteBanner.bannerSelector);
    console.log(banner);
    banner.remove();
  }
}
